import { omitBy, isNil, omit } from "lodash";
import moment from "moment";

const constructDateString = (date, strFormat = "DD-MM-YYYY", skipChecking = false) => {
  if (!date) return null;

  if (skipChecking) return date;

  const isMoment = moment(date).isValid();

  if (!isMoment) return null;

  return moment(date).format(strFormat);
};

const model = (data: any) => {
  const { isNewVersion } = data;

  // such a pain in the ... managing this
  return omitBy(
    {
      type: data.type,
      code: data.code || null,
      settingID: data.settingID || null,
      fields: omitBy(
        {
          ...omit(data, [
            "type",
            "code",
            "settingID",
            "surchargeType",
            "surchargeFixedAmount",
            "surchargeCapAmount",
            "surchargePercentage",
            "locationsData",
            "isNewVersion",
          ]),
          cutOffTime: constructDateString(data?.cutOffTime, "HH:mm", isNewVersion),
          estimatedDeliveryInDay: data?.estimatedDeliveryInDay,
          estimatedTime: constructDateString(data?.estimatedTime, "HH:mm", isNewVersion),
        },
        isNil,
      ),
    },
    (value) => isNil(value),
  );
};

export default model;
